import { render, staticRenderFns } from "./Ordersform.vue?vue&type=template&id=364bff86"
import script from "./Ordersform.vue?vue&type=script&lang=js"
export * from "./Ordersform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports